import Java from './Java.vue';
export default Java;
